export const en = {
    //home page
    downloadResume: "Our CV",
    loadMoreProducts: "Load More Products",
    readMoreReviews: "Read More Reviews",
    moreAboutUs: "More About Us",
    Result: `Drive Result With `,
    Digital: `digital`,
    Solution: "Solution ",
    provide: "We provide creative and technical solution for businesses to engage with their target audience through digital channels",
    ourServices: "Our Services",
    ServicesText: " Lorem ipsum odor amet, consectetuer adipiscing elit",
    TopProducts: "Top Products",
    CustomerFeedback: "Customer Feedback",
    CustomerText: `
        Lorem ipsum odor amet,
        consectetuer adipiscing elit.Hac dictum ornare himenaeos fusce venenatis.Litora interdum dapibus dictum vel pulvinar eu.Lorem ipsum odor amet,
        consectetuer adipiscing elit...
        `,
    role: "name . Role",
    textAboutUs: `
        Noova company with registration number
        16154778 started its work  in 2018. The founders of this company with more than ten years of experience in the field of programming and startup environment of the country,
        using their own experience and that of others,
        started to establish They participated.
        `,
    OurProcess: "Our Process",
    OurTrustedPartner: "Our customers",
    Explore: "Explore your business ideas with our modern strategies",
    team: "Our team is ready to help you achieve your business goals with creative and modern digital marketing strategies",
    //certification page
    Certification: "Certification",
    Description: "Description",

    //blog page
    Blogs: "Blogs",
    Marketing: "Marketing",
    readMore: "Read More",
    btnMoreBlog: "Load More Blogs",
    //header
    Home: "Home",
    Products: "Products",
    Projects: "Projects",
    AboutUs: "About Us",
    ContactUs: "Contact Us",
    ChangeLang: "Change Language to",
    Farsi: "Farsi",
    SwitchMode: "Switch to",
    darkMode: "Dark mode",
    lightMode: "Light mode",
    lng: "Fa",
    //footer
    footerText: `
        NooVA company is a forward-thinking technology company specializing in web and mobile software development. Our core expertise lies in designing and developing high-quality iOS and Android applications, as well as cutting-edge websites tailored to meet the evolving digital landscape.

At NooVA, we are not just developers—we are creators, innovators, and problem-solvers. We thrive on bringing fresh ideas to life, working closely with startups and businesses to craft unique, user-friendly, and impactful digital products `,

    QuickLinks: "Quick links",
    Support: "Support",
    Address: "Address",
    allJob: "All Job",
    //about us page
    aboutTitle: "Noova company",
    aboutDescription: "Noova company, we believe in the power of digital marketing and help you to take your brand to the top by using new strategies. Since our establishment in 2019, our goal has been to provide innovative and effective solutions in the digital world. With a team of experts and successful experiences in various fields, we help you stand out online.",
    OurMission: "Our Mission",
    OurMissionDescription: `
        Our mission is to promote brands and businesses through modern and
        creative strategies.We help you achieve your business goals using
        technology and digital innovations.
        `,
    companyVision: "company vision",
    companyVisionDescription: "Currently, the company's plan is on the development of external products (applications and websites) and focusing on the fields of artificial intelligence and  conducting internal automation projects.",
    Awards: "Awards and Honor",
    AwardsDescription2018: "The final candidate for the best app in the Iran App and Mobile Festival in 2018 ",
    AwardsDescription1400: "The final candidate for the best project in the festival of the province of Up country in 1400",
    //detailBlog
    name: "name",
    role: "Role",
    data: "6 September 2024",
    Introduction: "Introduction",
    relatedPosts: "Related posts",
    //job
    JobOpportunities: "Job opportunities",
    designer: "Ui Ux designer",
    ago: "2 day ago",
    JobText: "Lorem ipsum odor amet, consectetuer adipiscing elit. Hac dictum ornare himenaeos fusce venenatis. Litora interdum dapibus dictum vel pulvinar eu. Lorem ipsum odor amet, consectetuer adipiscing elit.Lorem ipsum odor amet, consectetuer adipiscing elit. Hac dictum ornare himenaeos fusce venenatis. Litora interdum dapibus dictum vel pulvinar eu. Lorem ipsum odor ame ...",
    open: "open",
    pending: "pending",
    closed: "closed",
    //product
    uiUxDesign: "All",
    uiUxDesign1: "ui ux design",
    uiUxDesign2: "ui ux design",
    uiUxDesign3: "ui ux design",
    irangardi: "Irangardi",
    moreInformation: "More Information",
    productText: " Lorem ipsum odor amet, consectetuer adipiscing elit. Hac dictum ornare himenaeos fusce venenatis. Litora interdum dapibus dictum vel pulvinar eu. Lorem ipsum odor amet, consectetuer adipiscing elit.",
    Load: "Load more Job",
    loadMoreProjects: "load more projects",

    //detail p
    gallery: "Gallery product",
    journey: `
        A visual journey to the world of beauty the digital experience of `,
    irangardiText1: "Are you ready to get to know the latest digital experience in the world of natural landscapes? By watching these animations, enjoy the creative design and advanced features of our site and application and start your journey.",
    Introduction: "Product Introduction",

    irangardiDescription: "Our goal is to create a comprehensive digital platform to discover and introduce natural landscapes and outdoor activities in Iran. By using Irangerdi, users can easily find beautiful sights and activities that suit their interests and optimize their travel planning. This platform allows you to manage the equipment needed for travel and enjoy a unique experience in discovering natural attractions.",
    TopFeatures: "Top Features",
    ShowWeather: "Show weather conditions",
    irangardiText4: "Users can add their gear and equipment list for each activity so that they have everything with them when preparing for a trip.",
    BackpackManagement: "Backpack Management",
    irangardiText3: "The platform provides users with detailed information about the weather conditions of selected locations so that they can better plan their trip.",
    InteractiveMap: "Interactive map",
    irangardiText5: "Users can view natural places in detail through interactive maps and plan access routes to them.",
    TechnicalDetails: "Technical Details",
    OtherFeatures: "Other Features",
    Discovering: "Discovering natural landscapes",
    irangardiText6: "Users can search for natural and pristine places. This section allows users to find their ideal places using various filters, such as activity type (hiking, climbing, etc.), route difficulty, geographical location and travel season.",
    Comprehensive: "Comprehensive information",
    irangardiText7: "For each location, comprehensive and complete information is provided, including trail descriptions, weather conditions, real photos from users, and other naturalist comments.",
    Choose: "Choose your favorite activities",
    irangardiText8: "Users can search and select suitable places based on their interests, such as hiking, climbing, cycling, etc.",
    Product: "product",
    visitWebsite: "Visit Website",
    take: "Take a look at the beauty of Iran travel! Visit our website now!",
    Discover: "Discover the world of beauty by downloading irangardi application",
    downloadApplication: "Download Application",

    //jobDes
    JobDescription: "Job Description",
    palaseHolderName: "Enter your first name",
    palaseHolderFamily: "Enter your last name",
    palaseHolderEmail: "Enter your Email",
    palaseHolderPhone: "your phone number",
    labelName: "First name",
    labelLastName: "Last name",
    labelEmail: "Email",
    labelNumber: "Your number",
    CV: "CV",
    Upload: "Upload File",
    Max: "!Max file size 30 Mb",
    send: "Send",
    sending: "Sending...",
    //contact page
    Message: "Your Message",
    Message2: "Your Message",
    address: "Connect with location",
    email: "Connect with email",
    phone: "Connect with call",
    phoneNumber: " +44 7572 079872",
    whatsapp: "Connect with whatsapp",
    phoneRequired: "Please enter your phone number",
    fileRequired: "Select resume file",
    phoneInvalid: "The phone number entered is invalid",
    emailRequired: "Please enter your email address",
    emailInvalid: "The email format is incorrect",
    nameRequired: "Please enter your first name",
    lastNameRequired: "Please enter your last name",
    messageRequired: "Please enter your message",
    SuccessMessage: "Information was successfully saved.",
    errorMessage: "error occurred",
    errorServerMessage: "A server error occurred",
    Loading: "Loading...",
};